/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { StyledBox, StyledTypography } from "./style";
import { Divider } from "@mui/material";

export const MenuHeading = ({ children, report = true, dataTestId = '', rightComponent, dividerStyle }) => {
  return (
    <StyledBox report={report} data-testid={dataTestId}>
      {rightComponent ? (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <StyledTypography report={report} variant="subtitle1">
            {children}
          </StyledTypography>
          {rightComponent}
        </div>
      ) : (
        <StyledTypography report={report} variant="subtitle1">
          {children}
        </StyledTypography>
      )}
      <Divider style={{ borderStyle: "solid", borderWidth: "1px", ...dividerStyle }} />
    </StyledBox>
  );
};
